import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AgentSource } from 'AgentApp/ts/interfaces/client-context';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

export interface AgentSuggestedPrompts {
    prompts: string[];
}

@Injectable({ providedIn: 'root' })
export class AgentSuggestedPromptsService {
    private readonly _ajaxService = inject(AjaxService);

    private readonly _urlsService = inject(UrlsService);

    getSuggestedPrompts(
        url: string,
        pageTitle: string,
        source: AgentSource,
        regenerate = false,
        currentPrompts: string[] = []
    ): Observable<AgentSuggestedPrompts> {
        const { path, params } = this._parsePageState(url);
        const body = {
            path,
            params,
            page_title: pageTitle,
            source,
            ...(regenerate ? { regenerate: true, exclude_prompts: currentPrompts } : {}),
        };
        return this._ajaxService.postJsonDataObserveBody<AgentSuggestedPrompts>(
            this._urlsService.AGENT.SUGGESTED_PROMPTS,
            body
        );
    }

    // parse page state from url for certain apps
    private _parsePageState(url: string): { path: string; params: Record<string, string> } {
        const params: Record<string, string> = {};
        if (!url) {
            return { path: '', params };
        }
        const parsed = new URL(url);
        parsed.searchParams.forEach((value, key) => {
            params[key] = value;
        });
        const hashQueryStart = parsed.hash.indexOf('?');
        if (hashQueryStart !== -1) {
            new URLSearchParams(parsed.hash.slice(hashQueryStart + 1)).forEach((value, key) => {
                params[key] = value;
            });
        }
        return { path: parsed.pathname, params };
    }
}
